<template>
  <route-settings />
</template>

<script>
import RouteSettings from "@/components/3pl/Settings/RoutesAndVehicles/Routes/index";
export default {
  components: {
    RouteSettings,
  },
};
</script>

<style></style>
